import { VehicleStatesTypesID } from "@shared/constants/vehicle-states-types.enum";
import { Location } from "@shared/interfaces/location.interface";
import { Travel } from "@shared/interfaces/travel.interface";

/** Where the arrival forecast of a vehicle card points to, and the state the vehicle reaches there. */
export interface ArrivalForecastTarget {
  location: Location;
  stateId: VehicleStatesTypesID;
}

/**
 * Pick where the arrival forecast points to: the jobsite while the vehicle is on the way, and the plant the
 * travel left from while it is returning. Other states, or a travel without that location, have no forecast.
 * @param stateId Current state of the vehicle
 * @param travel Current travel of the vehicle
 */
export const getArrivalForecastTarget = (
  stateId: VehicleStatesTypesID | string,
  travel?: Pick<Travel, "origin" | "destination">
): ArrivalForecastTarget | null => {

  if (stateId === VehicleStatesTypesID.A_CAMINHO && travel?.destination) {
    return { location: travel.destination, stateId: VehicleStatesTypesID.EM_OBRA };
  }

  if (stateId === VehicleStatesTypesID.RETORNANDO && travel?.origin) {
    return { location: travel.origin, stateId: VehicleStatesTypesID.NA_USINA };
  }

  return null;
};
